import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProblemInstanceService } from 'planner-shared';

import { PatientMainResponsibleView } from '../models/patient-main-responsible-view.model';

@Injectable({
    providedIn: 'root'
})
export class PatientMainResponsiblesService {
    private readonly problemInstanceService = inject(ProblemInstanceService);


    public getMainResponsibles(patientId: string): Observable<PatientMainResponsibleView[]> {
        return this.problemInstanceService.getProblemInstance().pipe(
            map(result => {
                const patient = result.problemInstance.patients.find(p => p.patientId === patientId);
                const patientMainResponsibles = result.problemInstance.patientMainResponsibles.find(
                    p => p.patientId === patientId
                );

                if (!patientMainResponsibles) {
                    return [];
                }

                return patientMainResponsibles.employeeIdsMainResponsibles.map(employeeId => {
                    const responsibleEmployee = result.problemInstance.employees.find(e => e.employeeId === employeeId);
                    const employeeIsPrimary = this.employeeIsContact(employeeId, patient.primaryContactId);
                    const employeeIsSecondary = this.employeeIsContact(employeeId, patient.secondaryContactId);
                    return <PatientMainResponsibleView>{
                        employeeId,
                        employeeName: responsibleEmployee.employeeName,
                        initials: responsibleEmployee.initials,
                        primaryContact: employeeIsPrimary,
                        secondaryContact: employeeIsSecondary,
                        description: this.findDescription(employeeIsPrimary,
                            employeeIsSecondary)
                    };
                });
            })
        );
    }
    private employeeIsContact(employeeId: string, contactId: string): boolean {
        return employeeId === contactId;
    }
    private findDescription(primary: boolean, secondary: boolean): string {
        if (primary) {
            return 'PRIMARY_CONTACT';
        } else if (secondary) {
            return 'SECONDARY_CONTACT';
        } else {
            return 'MAIN_RESPONSIBLE';
        }
    }
}
